import React from 'react';
import SkeletonBone from './SkeletonBone';
import './loading.css';

const SkeletonMap = ({ className = '' }) => (
  <SkeletonBone
    className={`skeleton-map ${className}`.trim()}
    aria-hidden="true"
  />
);

export default SkeletonMap;
